import { render, staticRenderFns } from "./CustomHeading.vue?vue&type=template&id=201a9ba7&"
import script from "./CustomHeading.vue?vue&type=script&lang=js&"
export * from "./CustomHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports